//#region import libraries
import React from 'react';
//bootstrap
import Row from 'react-bootstrap/Row';
//custom components
import { Backbutton } from "_molecules";
import { Title, NewScreen } from "_atoms";
import { ProductAnalytics } from '_organisms';
import CreateProduct from '_scenes/portal/marketplace/create-product/index';

const EditReward = () => {

    return (
        <NewScreen>
            <Row>
                {/* Title */}
                <Title name="Marketplace" />
                <Backbutton page="my-rewards" />
                <ProductAnalytics />
            </Row>

            <CreateProduct editReward={true} sidebar={false}></CreateProduct>

        </NewScreen>
    );
}

export default EditReward;
